import React from 'react';

import TextField from '@mui/material/TextField';

import type { FieldValues } from './CreditReportUpdateModal';
import { useFormField } from './CreditReportUpdateModal';

type MemoTextFieldSSNProps = {
  label: string;
  margin?: any;
  className?: string;
  sx?: object;
  fieldName: string;
  children?: React.ReactNode;
  placeholder?: string;
  id?: string;
  variant?: any;
  type?: string;
  error?: boolean;
  inputProps?: object;
  endAdornment?: React.ReactNode;
};

export default function MemoTextFieldSSN(props: MemoTextFieldSSNProps) {
  const {
    fieldName,
    children,
    sx,
    label,
    margin,
    className,
    placeholder,
    id,
    variant,
    type,
    inputProps,
    endAdornment,
  } = props as MemoTextFieldSSNProps;

  const { value, onChange, helperText } = useFormField(fieldName as keyof FieldValues);

  return (
    <TextField
      id={id}
      value={value}
      helperText={helperText}
      error={helperText === '' || !!helperText}
      placeholder={placeholder || 'xxx-xx-xxxx'}
      label={label}
      margin={margin}
      variant={variant}
      onChange={onChange}
      className={className}
      sx={sx}
      type={type}
      InputProps={{
        ...inputProps,
        endAdornment,
        autoComplete: 'off',
      }}
      inputProps={{
        maxLength: 11,
      }}
      fullWidth
      autoFocus
    >
      {children}
    </TextField>
  );
}
